import { SplitPane, type SplitPaneProps } from '@rexxars/react-split-pane';
import type { ReactNode } from 'react';
import clsx from 'clsx';

// Extend SplitPaneProps but make children mandatory and typed
type TestSplitPaneProps = Omit<SplitPaneProps, 'children'> & {
  children: [ReactNode, ReactNode];
};

const defaultSplitPaneProps = {
  split: 'vertical' as const,
  // min size for the first pane
  minSize: 430,
  // max size for the first pane
  maxSize: typeof window !== 'undefined' ? window.innerWidth * 0.7 : 1000,
  resizerClassName:
    'w-[2px] bg-gray-300 dark:bg-gray-700 z-10 transition-colors duration-200 ease-in-out hover:bg-gray-400 dark:hover:bg-gray-600 cursor-col-resize editor-browser-divider',
};

export default function TestSplitPane({ children, ...restProps }: TestSplitPaneProps) {
  const combinedProps = { ...defaultSplitPaneProps, ...restProps };

  return (
    <SplitPane
      {...combinedProps}
      pane1ClassName={clsx('overflow-auto', combinedProps.pane1ClassName)}
      pane2ClassName={clsx('overflow-auto', combinedProps.pane2ClassName)}
    >
      {children}
    </SplitPane>
  );
}
